/**
 * Capitalizes the first letter of a string
 */
export const capitalizeFirstLetter = (string: string) => string.charAt(0).toUpperCase() + string.slice(1);

export const convertStringToList = (string: string): string[] => string
    .trim()
    .split(/\n|\s|,/)
    .filter((i) => i !== '');
